import { UTC }                                   from 'rewire-common';
import DataMutations                             from '../graphql/Mutations';
import ArchiveDeleteDialogModel                  from './ArchiveDeleteDialogModel';
import { ArchiveDeleteAreaConfirmationContent }  from './ArchiveDeleteAreaDialog';

export class ArchiveDeleteAreaDialogModel extends ArchiveDeleteDialogModel {
  constructor() {
    super('areas');
  }

  async _delete(id: string, endDate: UTC): Promise<boolean> {
    return !!(await DataMutations.deleteAreas([id], endDate));
  }

  _getConfirmationContentComponent() {
    return ArchiveDeleteAreaConfirmationContent;
  }
}

const archiveDeleteAreaDialogModel = new ArchiveDeleteAreaDialogModel();
export default archiveDeleteAreaDialogModel;